import { NgModule } from '@angular/core';
import { I18nPipe } from './pipe/i18n.pipe';
import { FooterComponent } from './components/footer/footer.component';
import { FOOTER_I18N_ENTRIES } from './i18n/footer-i18n-entries';
import { I18nService } from './service/i18n.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { COOKIES_CONFIG_I18N_ENTRIES } from './i18n/cookies-config-i18n-entries';
import { CookiesConfigComponent } from './components/cookies-config/cookies-config.component';
import { OptionalCookiesDialogComponent } from './components/cookies-config/optional-cookies-dialog/optional-cookies-dialog.component';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from './components/error/error.component';
import { ERROR_I18N_ENTRIES } from './i18n/error-i18n-entries';
import { ContactComponent } from './components/contact/contact.component';
import { CONTACT_I18N_ENTRIES } from './i18n/contact-i18n-entries';
import { INVOICE_PDF_I18N_ENTRIES } from './i18n/invoice-pdf-i18n-entries';
import { LoaderComponent } from './components/loader/loader.component';
import { LOADER_I18N_ENTRIES } from './i18n/loader-i18n-entries';
import { InfiniteSliderComponent } from '../home/components/infinite-slider/infinite-slider.component';
import { INFINITE_SLIDER_I18N_ENTRIES } from '../home/i18n/infinite-slider-i18n-entries';
import { METRICS_I18N_ENTRIES } from './i18n/metrics-i18n-entries';
import { HeaderComponent } from './components/header/header.component';
import { HEADER_I18N_ENTRIES } from './i18n/header-i18n-entries';
import { LazyLoadDirective } from '../lazy-load.directive';

@NgModule({
  declarations: [
    I18nPipe,
    FooterComponent,
    CookiesConfigComponent,
    OptionalCookiesDialogComponent,
    ErrorComponent,
    ContactComponent,
    LoaderComponent,
    InfiniteSliderComponent,
    HeaderComponent,
    LazyLoadDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    RouterModule,
    MatDialogModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
  ],
  exports: [
    I18nPipe,
    FooterComponent,
    FormsModule,
    RouterModule,
    MatSelectModule,
    MatDialogModule,
    CookiesConfigComponent,
    OptionalCookiesDialogComponent,
    ReactiveFormsModule,
    ErrorComponent,
    ContactComponent,
    LoaderComponent,
    InfiniteSliderComponent,
    HeaderComponent,
    LazyLoadDirective
  ],
})
export class CommonsModule {
  constructor(private i18nService: I18nService) {
    i18nService.addI18nEntriesObject(FOOTER_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(COOKIES_CONFIG_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(ERROR_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(CONTACT_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(INVOICE_PDF_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(LOADER_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(INFINITE_SLIDER_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(METRICS_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(HEADER_I18N_ENTRIES);
  }
}
